/* uri encode template values */
function url(strings, ...interpolations) {
  let str = strings[0]
  for (let i = 0; i < interpolations.length; i++) {
    str += encodeURIComponent(interpolations[i])
    str += strings[i + 1]
  }
  return str
}

export class ShareLinks extends HTMLElement {
  connectedCallback() {
    const info = this.shareInfo
    this.facebookLink?.setAttribute('href', url`https://www.facebook.com/sharer.php?u=${info.url}`)

    this.twitterLink?.setAttribute(
      'href',
      url`https://twitter.com/intent/tweet?url=${info.url}&text=${info.tittel}`,
    )

    this.emailLink?.setAttribute(
      'href',
      url`mailto:?subject=${info.tittel}&body=${`${info.ingress}\r\n\r\nLes mer: ${info.url}`}`,
    )
  }

  get shareInfo() {
    return {
      url: document.querySelector("meta[property='og:url']")?.getAttribute('content') ?? '',
      tittel: document.querySelector("meta[property='og:title']")?.getAttribute('content') ?? '',
      ingress:
        document.querySelector("meta[property='og:description']")?.getAttribute('content') ?? '',
    }
  }

  get facebookLink() {
    return this.querySelector('[data-share="Article:Facebook"]')
  }

  get twitterLink() {
    return this.querySelector('[data-share="Article:Twitter"]')
  }

  get emailLink() {
    return this.querySelector('[data-share="Article:Epost"]')
  }
}
